import { render } from "./talentpolicyDetail.vue?vue&type=template&id=41f8898e&scoped=true"
import script from "./talentpolicyDetail.vue?vue&type=script&lang=js"
export * from "./talentpolicyDetail.vue?vue&type=script&lang=js"

import "./talentpolicyDetail.vue?vue&type=style&index=0&id=41f8898e&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f8898e"]])

export default __exports__